import classNames from 'classnames';

export const getOrientationType = (damImageAlignmentBehavior = '', descriptionAlignment = '', richText = '') => {
  return {
    isCentered: damImageAlignmentBehavior === 'Centered',
    isVertical: descriptionAlignment === 'Below image' || descriptionAlignment === 'Above image' || !richText,
    imageFirst: descriptionAlignment === 'Below image' || descriptionAlignment === 'To the right of the image'
  };
};

export const getImageAndTextWidthClasses = (damImageWidthBehavior = '', isVertical = false) => {
  switch (damImageWidthBehavior) {
  case 'Skinny':
    return {
      imageWidthClasses: `sui-col-span-12 ${isVertical
        ? 'sm:sui-col-span-8 md:sui-col-span-6' : 'sm:sui-col-span-6 md:sui-col-span-4'}`,
      textWidthClasses: `sui-col-span-12 ${isVertical ? '' : 'sm:sui-col-span-6 md:sui-col-span-8'}`
    };
  case 'Wide':
    return {
      imageWidthClasses: `sui-col-span-12 ${isVertical ? '' : 'sm:sui-col-span-6 lg:sui-col-span-8'}`,
      textWidthClasses: `sui-col-span-12 ${isVertical ? '' : 'sm:sui-col-span-6 lg:sui-col-span-4'}`
    };
  default:
    return {
      imageWidthClasses: `sui-col-span-12 ${isVertical ? 'sm:sui-col-span-8' : 'sm:sui-col-span-6'}`,
      textWidthClasses: `sui-col-span-12 ${isVertical ? '' : 'sm:sui-col-span-6'}`
    };
  }
};

export const getTextPaddingClasses = (descriptionAlignment = '') => {
  switch (descriptionAlignment) {
  case 'Below image':
    return 'sui-pt-4 md:sui-pt-6 xl:sui-pt-8';
  case 'Above image':
    return 'sui-pb-4 md:sui-pb-6 xl:sui-pb-8';
  case 'To the right of the image':
    return 'sui-pt-4 sm:sui-pt-0 sm:sui-pl-4 md:sui-pl-6 xl:sui-pl-8';
  case 'To the left of the image':
    return 'sui-pb-4 sm:sui-pb-0 sm:sui-pr-4 md:sui-pr-6 xl:sui-pr-8';
  default:
    return '';
  }
};

export const getLeftSpaceClasses = ({
  isVertical = false, isCentered = false, damImageWidthBehavior = ''
}) => {
  if (isVertical && isCentered) {
    return classNames('sui-col-start-0', {
      'sm:sui-col-start-3 md:sui-col-start-3 xl:sui-col-start-3': damImageWidthBehavior === 'Normal',
      'sm:sui-col-start-3 md:sui-col-start-3 xl:sui-col-start-4': damImageWidthBehavior === 'Skinny',
    });
  }
  return 'sui-col-start-0';
};